'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _extends = require('@babel/runtime/helpers/extends');
var React = require('react');
var reactContainerQuery = require('react-container-query');
var styled = require('styled-components');
var useResizeObserver = require('@react-hook/resize-observer');
var nthHookTheme = require('@narvar/nth-hook-theme');
var nthHookSettings = require('@narvar/nth-hook-settings');
var nthHookTranslations = require('@narvar/nth-hook-translations');
var index$2 = require('./ReturnReasonsList/index.js');
var index$4 = require('./ReturnReasonsQuantity/index.js');
var index$3 = require('./ReturnReasonsQuantityAll/index.js');
var index$6 = require('./ReturnReasonsComments/index.js');
var styles = require('./styles.js');
var useLanguage = require('../../hooks/useLanguage.js');
require('../../components/StyledMarkup/index.js');
require('../../components/Spinner/index.js');
require('../../components/Button/styles.js');
require('../../components/LocationCard/index.js');
require('../../components/PudoCard/index.js');
var index$b = require('../../components/ItemCard/index.js');
require('../../components/SelectItem/index.js');
require('../../components/SelectList/index.js');
require('../../components/ErrorBanner/index.js');
var index$9 = require('../../components/Footer/index.js');
var index$8 = require('../../components/StickyFooter/index.js');
require('../../components/SwatchesList/index.js');
require('@narvar/nth-bit-text-link');
require('../../components/Backdrop/index.js');
require('../../components/LineItemsGroup/index.js');
require('../../components/Skeleton/ItemCardSkeleton.js');
require('../../components/Skeleton/LineItemSkeleton.js');
require('../../components/Skeleton/PudoCardSkeleton.js');
var helper = require('../ItemSelector/helper.js');
var index = require('./ReturnReasonsEdit/index.js');
var tokens = require('./tokens.js');
var index$a = require('../../components/BackButton/index.js');
var index$1 = require('./ReturnReasonsType/index.js');
var path = require('./path.js');
var index$7 = require('./ReturnReasonsExchange/index.js');
var index$5 = require('./ReturnReasonsPictures/index.js');
var formData = require('./formData.js');
var style = require('../../transformers/style.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var useResizeObserver__default = /*#__PURE__*/_interopDefaultLegacy(useResizeObserver);

const reasonOptionPayload = _ref => {
  let {
    type,
    selection,
    customerComments = '',
    pictures,
    quantity,
    item,
    exchangeTo,
    exchangeSelections = {}
  } = _ref;
  const selectionNode = selection[selection.length - 1];
  const parent = selection.length > 1 ? selection[selection.length - 2].id : '';
  return {
    type,
    selectedReason: {
      id: (selectionNode === null || selectionNode === void 0 ? void 0 : selectionNode.id) || '',
      name: (selectionNode === null || selectionNode === void 0 ? void 0 : selectionNode.name) || '',
      category: selectionNode === null || selectionNode === void 0 ? void 0 : selectionNode.name,
      parent
    },
    pictures,
    customerComments,
    path: selection,
    quantity,
    item,
    exchangeTo,
    selectedExchangeOptions: exchangeSelections
  };
};
const query = {
  above700: {
    minWidth: 700
  }
};
const noop = () => {};
const ReturnReasonsRawComponent = _ref2 => {
  var _orderItem$eligibilit, _stepsProps$exchanges, _orderItem$eligibilit2;
  let {
    locale,
    includeCurrency,
    orderItem,
    selectedItem,
    stepsProps,
    exchangeOptions,
    exchangeVariants,
    value,
    layout,
    loading,
    defaultType,
    onNext,
    onChange,
    onSubmit,
    onBack,
    onClose,
    onError
  } = _ref2;
  const {
    itemDisplay,
    returnReasons
  } = nthHookSettings.useSettings();
  const {
    returnQuantityMustBeAll
  } = returnReasons ?? {};
  const {
    buttonsPrimaryDefault,
    selecteditemNoneNone
  } = nthHookTheme.useTheme();
  const returnEnabled = (_orderItem$eligibilit = orderItem.eligibilities.return) === null || _orderItem$eligibilit === void 0 ? void 0 : _orderItem$eligibilit.isEligible;
  const exchangeEnabled = (stepsProps === null || stepsProps === void 0 ? void 0 : (_stepsProps$exchanges = stepsProps.exchanges) === null || _stepsProps$exchanges === void 0 ? void 0 : _stepsProps$exchanges.enabled) && ((_orderItem$eligibilit2 = orderItem.eligibilities.exchange) === null || _orderItem$eligibilit2 === void 0 ? void 0 : _orderItem$eligibilit2.isEligible);
  // No exchange options is provided, probably there is only one variant, which
  // is the original product.
  const skipExchangeSelection = !loading && (exchangeOptions === null || exchangeOptions === void 0 ? void 0 : exchangeOptions.length) === 0 && exchangeVariants && (exchangeVariants === null || exchangeVariants === void 0 ? void 0 : exchangeVariants.length) > 0;
  // If there is no exchange options, or no available exchange variants, or
  // every variants are from the returning product, hide exchange upsell in the
  // last step of the return flow.
  const availableExchangeVariants = (exchangeVariants === null || exchangeVariants === void 0 ? void 0 : exchangeVariants.filter(variant => variant.available)) ?? [];
  const skipUpsellSelection = !loading && ((exchangeOptions === null || exchangeOptions === void 0 ? void 0 : exchangeOptions.length) === 0 || availableExchangeVariants.length === 0 || availableExchangeVariants.every(variant => variant.productId === orderItem.productId));
  const statefulValues = !value;
  const _formData = formData.useReturnReasonsFormData({
    orderItem,
    selectedItem,
    defaultType: defaultType || (returnEnabled && !exchangeEnabled ? 'return' : undefined)
  });
  const valueWithFallback = statefulValues ? _formData.values : value;
  const {
    type,
    selection,
    quantity,
    pictures,
    customerComments,
    exchangeSelections,
    exchangeTo
  } = valueWithFallback;
  const resetValue = statefulValues ? _formData.reset : noop;
  const updateValue = statefulValues ? _formData.update : noop;
  const stepsState = path.useReturnReasonsPath({
    returnQuantityMustBeAll,
    orderItem,
    selectedItem,
    returnEnabled,
    exchangeEnabled,
    skipExchangeSelection,
    skipUpsellSelection,
    stepsProps,
    value: valueWithFallback,
    defaultType: defaultType || (returnEnabled && !exchangeEnabled ? 'return' : undefined)
  });
  const {
    isLastStep,
    isCompleted,
    path: path$1,
    next: goNext,
    back: goBack
  } = stepsState;
  const currentStepData = path$1[path$1.length - 1];
  const currentStep = currentStepData.step;
  React.useEffect(() => {
    if (skipExchangeSelection && type === 'exchange' && !exchangeSelections) {
      updateValue({
        exchangeTo: exchangeVariants[0],
        exchangeSelections: {}
      });
    }
  }, [skipExchangeSelection, type, exchangeVariants, exchangeSelections, updateValue]);
  const [params, containerRef] = reactContainerQuery.useContainerQuery(query, {});
  const selectedQuantity = (selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.quantity) || quantity;
  const footerButtons = React.useMemo(() => {
    const ret = {};
    const convertButtonProps = nav => ({
      outline: nav.type === 'back' || nav.type === 'cancel',
      ...nav,
      big: !params.above700
    });
    const current = path$1[path$1.length - 1];
    const buttons = current.navigation.map(convertButtonProps);
    if (buttons.length === 1) {
      ret.centerButton = buttons[0];
    } else if (buttons.length === 2) {
      ret.leftButton = buttons[0];
      ret.rightButton = buttons[1];
    } else if (buttons.length >= 3) {
      ret.leftButton = buttons[0];
      ret.centerButton = buttons[1];
      ret.rightButton = buttons[2];
    }
    return ret;
  }, [path$1, params.above700]);

  // When we have `footerNav` layout and it is a mobile view. We need extra
  // padding bottom to make sure the main content won't be covered by the sticky
  // footer. Since the footer height varies based on the state of return item
  // (eg. number of variant options), we compute the padding dynamically with
  // min. 200px (ItemCard's height(~160px) + height of button row(40px))
  const min200 = x => Math.max(x, 200);
  const [paddingBottom, setPaddingBottom] = React.useState();
  const rootStyle = React.useMemo(() => ({
    paddingBottom,
    position: layout === 'footerAbsolute' ? 'static' : 'relative'
  }), [paddingBottom, layout]);
  const footerRef = React.useRef(null);
  const resizeHandler = () => {
    var _footerRef$current, _footerRef$current$ge;
    if (params.above700 || layout !== 'footerNav' && layout !== 'footerAbsolute') return;
    const {
      height = 0
    } = (footerRef === null || footerRef === void 0 ? void 0 : (_footerRef$current = footerRef.current) === null || _footerRef$current === void 0 ? void 0 : (_footerRef$current$ge = _footerRef$current.getBoundingClientRect) === null || _footerRef$current$ge === void 0 ? void 0 : _footerRef$current$ge.call(_footerRef$current)) ?? {};
    setPaddingBottom(min200(height) + 24);
  };
  useResizeObserver__default["default"](footerRef, resizeHandler);
  React.useEffect(resizeHandler, [params.above700, layout, footerRef]);
  const {
    rawValue: skuLabel
  } = useLanguage["default"]({
    langKey: 'returnsItemListItemInfoskuLabel'
  });
  const {
    rawValue: qtyLabel
  } = useLanguage["default"]({
    langKey: 'returnsItemListItemInfoqtyLabel'
  });
  const {
    rawValue: colorLabel
  } = useLanguage["default"]({
    langKey: 'returnsItemListItemInfocolorLabel'
  });
  const {
    rawValue: sizeLabel
  } = useLanguage["default"]({
    langKey: 'returnsItemListItemInfosizeLabel'
  });
  const {
    rawValue: priceLabel
  } = useLanguage["default"]({
    langKey: 'returnsItemListItemInfopriceLabel'
  });
  const {
    rawValue: reasonLabel
  } = useLanguage["default"]({
    langKey: 'returnsItemListItemInforeasonLabel'
  });
  const selectedNode = selection[selection.length - 1];
  const cancelEvent = () => {
    onClose === null || onClose === void 0 ? void 0 : onClose({
      value: null,
      event: 'cancel',
      area: 'returnReason'
    });
    resetValue();
  };
  const handleChangeFactory = (subComponent, submitOnChange, overrideFunc) =>
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  event => {
    let updates = {
      type,
      selection,
      quantity,
      pictures,
      customerComments,
      exchangeSelections,
      exchangeTo
    };
    if (overrideFunc) {
      updates = {
        ...updates,
        ...overrideFunc(event)
      };
    } else {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-expect-error
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
      updates[subComponent] = event;
    }
    updateValue(updates);
    const payload = reasonOptionPayload({
      item: orderItem,
      ...updates
    });
    onChange === null || onChange === void 0 ? void 0 : onChange({
      value: payload,
      event: 'change',
      area: 'returnReason',
      subComponent
    });
    if (submitOnChange) {
      goNext(payload);
      onNext === null || onNext === void 0 ? void 0 : onNext({
        value: payload,
        event: 'next',
        area: 'returnReason',
        subComponent
      });
    }
  };
  const handleSubmitFactory = React.useCallback(
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  overrideFunc => event => {
    const override = overrideFunc === null || overrideFunc === void 0 ? void 0 : overrideFunc(event);
    onSubmit === null || onSubmit === void 0 ? void 0 : onSubmit({
      value: reasonOptionPayload({
        ...valueWithFallback,
        item: orderItem,
        ...override
      }),
      event: 'submit',
      area: 'returnReason'
    });
  }, [valueWithFallback, orderItem, onSubmit]);
  const handleBack = () => {
    if (selectedItem) {
      onClose === null || onClose === void 0 ? void 0 : onClose({
        value: reasonOptionPayload({
          type,
          selection,
          customerComments,
          pictures,
          quantity,
          item: orderItem,
          exchangeTo
        }) || null,
        event: 'back',
        area: 'returnReason',
        subComponent: 'edit'
      });
      resetValue();
    }
    const result = goBack();
    if (!result) {
      cancelEvent();
    } else {
      var _result$payload$excha;
      onBack === null || onBack === void 0 ? void 0 : onBack({
        value: result.payload,
        event: 'back',
        area: 'returnReason',
        subComponent: result.step
      });
      updateValue({
        ...result.payload,
        selection: result.payload.path,
        exchangeSelections: (_result$payload$excha = result.payload.exchangeTo) === null || _result$payload$excha === void 0 ? void 0 : _result$payload$excha.variantInfo
      });
    }
  };
  const handleNext = () => {
    const payload = reasonOptionPayload({
      type,
      selection,
      customerComments,
      pictures,
      quantity,
      item: orderItem,
      exchangeTo
    });
    goNext(payload);
    onNext === null || onNext === void 0 ? void 0 : onNext({
      value: payload,
      event: 'next',
      area: 'returnReason',
      subComponent: currentStep
    });
  };
  const handleEditChange = e => {
    onSubmit === null || onSubmit === void 0 ? void 0 : onSubmit({
      value: reasonOptionPayload({
        type,
        selection,
        customerComments,
        pictures,
        item: orderItem,
        quantity: e === 'remove' ? 0 : selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.quantity,
        exchangeTo
      }),
      event: 'change',
      area: 'returnReason',
      subComponent: 'edit'
    });
  };
  const handleFooterEvent = e => {
    if (e.value === 'back') {
      return handleBack();
    }
    if (e.value === 'next') {
      return handleNext();
    }
    if (e.value === 'submit') {
      return handleSubmitFactory(() => {
        if (currentStep === 'upsellSelector' && valueWithFallback.exchangeTo) {
          return {
            type: 'exchange'
          };
        }
        return {};
      })();
    }
  };
  React.useEffect(() => {
    if (isCompleted) {
      handleSubmitFactory()();
    }
  }, [isCompleted, handleSubmitFactory]);
  const getPreviewItemCard = footerPreview => {
    return /*#__PURE__*/React__default["default"].createElement(index$b.ItemCard, _extends__default["default"]({}, helper.getItemProps({
      item: orderItem,
      exchangeTo
    }), {
      attributes: helper.getItemAttrs({
        locale,
        includeCurrency,
        item: {
          ...orderItem,
          quantity: orderItem.remainingQuantity
        },
        itemDisplay,
        selectedQuantity,
        labels: {
          skuLabel,
          qtyLabel,
          colorLabel,
          sizeLabel,
          priceLabel
        },
        exchangeTo
      }),
      subtitle: currentStep === 'exchangeItemSelector' || currentStep === 'upsellSelector' ? exchangeTo === null || exchangeTo === void 0 ? void 0 : exchangeTo.availabilityStatus : null,
      additionalInfo: selectedNode && `${reasonLabel ?? ''}${(selectedNode === null || selectedNode === void 0 ? void 0 : selectedNode.name) ?? ''}`,
      layout: footerPreview ? undefined : 'vertical',
      selected: footerPreview,
      borderless: true,
      sTag: {
        borderRadius: 0,
        borderBottomRightRadius: (selecteditemNoneNone === null || selecteditemNoneNone === void 0 ? void 0 : selecteditemNoneNone.borderBottomRightRadius) ?? (selecteditemNoneNone === null || selecteditemNoneNone === void 0 ? void 0 : selecteditemNoneNone.borderRadius) ?? 3,
        backgroundColor: style.getBorderColor(selecteditemNoneNone) ?? (buttonsPrimaryDefault === null || buttonsPrimaryDefault === void 0 ? void 0 : buttonsPrimaryDefault.backgroundColor)
      }
    }));
  };
  const reasons = orderItem === null || orderItem === void 0 ? void 0 : orderItem.availableReasons;
  React.useEffect(() => {
    if (reasons) return;
    onError === null || onError === void 0 ? void 0 : onError({
      area: 'returnReason',
      error: {
        code: 'noReasonsFound',
        description: 'No reasons associated with this item'
      },
      event: 'init'
    });
  }, [onError, reasons]);
  if (!reasons) return null;
  return /*#__PURE__*/React__default["default"].createElement(styles.RootWrapper, {
    ref: containerRef,
    s: rootStyle
  }, /*#__PURE__*/React__default["default"].createElement(styles.Wrapper, null, params.above700 && getPreviewItemCard(), /*#__PURE__*/React__default["default"].createElement(styles.UserActions, null, (() => {
    var _stepsProps$pictures, _stepsProps$pictures2, _stepsProps$pictures3, _stepsProps$exchanges2;
    if (currentStep === 'editSelector') return /*#__PURE__*/React__default["default"].createElement(index["default"], {
      onChange: handleEditChange
    });
    if (currentStep === 'typeSelector') {
      var _currentStepData$opti, _currentStepData$opti2;
      return /*#__PURE__*/React__default["default"].createElement(index$1["default"], {
        allowReturn: (_currentStepData$opti = currentStepData.options.types) === null || _currentStepData$opti === void 0 ? void 0 : _currentStepData$opti.some(d => d === 'return'),
        allowExchange: (_currentStepData$opti2 = currentStepData.options.types) === null || _currentStepData$opti2 === void 0 ? void 0 : _currentStepData$opti2.some(d => d === 'exchange'),
        onChange: handleChangeFactory('type', true)
      });
    }
    if (currentStep === 'reasonSelector') return /*#__PURE__*/React__default["default"].createElement(index$2["default"], {
      onChange: handleChangeFactory('reasons', true, event => ({
        selection: [...selection, event]
      })),
      selection: selection,
      reasons: currentStepData.options.reasons ?? []
    });
    if (currentStep === 'quantityAll') return /*#__PURE__*/React__default["default"].createElement(index$3["default"], {
      onChange: isLastStep ? handleSubmitFactory(e => ({
        quantity: e
      })) // simple exchange with remainingQuantity > 1, or when comments are not allowed
      : handleChangeFactory('quantity', true) // We use the quantity subComponent in handleChangeFactory, as this component only returns totalQuantity or 0.
      ,
      totalQuantity: currentStepData.options.totalQuantity ?? orderItem.remainingQuantity
    });
    if (currentStep === 'quantitySelector') return /*#__PURE__*/React__default["default"].createElement(index$4["default"], {
      onChange: isLastStep ? handleSubmitFactory(e => ({
        quantity: e
      })) // simple exchange with remainingQuantity > 1
      : handleChangeFactory('quantity', true),
      totalQuantity: currentStepData.options.totalQuantity ?? orderItem.remainingQuantity,
      quantity: quantity
    });
    if (currentStep === 'picturesUploader') return /*#__PURE__*/React__default["default"].createElement(index$5["default"], {
      minCount: stepsProps !== null && stepsProps !== void 0 && (_stepsProps$pictures = stepsProps.pictures) !== null && _stepsProps$pictures !== void 0 && _stepsProps$pictures.required ? 1 : 0,
      maxCount: stepsProps === null || stepsProps === void 0 ? void 0 : (_stepsProps$pictures2 = stepsProps.pictures) === null || _stepsProps$pictures2 === void 0 ? void 0 : _stepsProps$pictures2.maxCount,
      maxSize: stepsProps === null || stepsProps === void 0 ? void 0 : (_stepsProps$pictures3 = stepsProps.pictures) === null || _stepsProps$pictures3 === void 0 ? void 0 : _stepsProps$pictures3.maxSize,
      pictures: pictures,
      hideSubmit: layout === 'footerNav' || layout === 'footerAbsolute',
      onChange: handleChangeFactory('pictures', false),
      onSubmit: handleNext
    });
    if (currentStep === 'commentsForm') {
      var _stepsProps$comments;
      const selectedReasonHasCommentRequired = selection.some(reason => {
        var _reason$comments;
        return reason === null || reason === void 0 ? void 0 : (_reason$comments = reason.comments) === null || _reason$comments === void 0 ? void 0 : _reason$comments.required;
      });
      // We use || instead of ??, because we want any instance of "true" to set isRequired.
      const isRequired = (stepsProps === null || stepsProps === void 0 ? void 0 : (_stepsProps$comments = stepsProps.comments) === null || _stepsProps$comments === void 0 ? void 0 : _stepsProps$comments.required) || selectedReasonHasCommentRequired || false;
      return /*#__PURE__*/React__default["default"].createElement(index$6.ReturnReasonsComments, {
        onChange: handleChangeFactory('customerComments', false),
        customerComment: customerComments ?? '',
        required: isRequired,
        hideSubmit: layout === 'footerNav' || layout === 'footerAbsolute',
        onSubmit: isLastStep ? handleSubmitFactory() : handleNext
      });
    }
    if (currentStep === 'exchangeItemSelector' || currentStep === 'upsellSelector') return /*#__PURE__*/React__default["default"].createElement(index$7["default"], {
      orderItem: orderItem,
      exchangeOptions: exchangeOptions ?? [],
      exchangeVariants: exchangeVariants ?? [],
      exchangeSelections: exchangeSelections,
      upsell: currentStep === 'upsellSelector',
      shopNow: stepsProps === null || stepsProps === void 0 ? void 0 : (_stepsProps$exchanges2 = stepsProps.exchanges) === null || _stepsProps$exchanges2 === void 0 ? void 0 : _stepsProps$exchanges2.shopNow,
      hideSubmit: layout === 'footerNav' || layout === 'footerAbsolute',
      onSkip: handleSubmitFactory(),
      onChange: handleChangeFactory('exchanges', false, event => {
        const update = {
          // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
          exchangeSelections: event.variantInfo,
          // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
          exchangeTo: event.exchangeTo
        };
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-assignment
        if (event.type) update.type = event.type;
        return update;
      }),
      loading: loading,
      onSubmit: isLastStep ? handleSubmitFactory(() => ({
        type: 'exchange'
      })) : handleNext
    });
    return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null);
  })(), layout === 'footerNav' && /*#__PURE__*/React__default["default"].createElement(index$8["default"], {
    fixed: !params.above700,
    removePadding: "inline"
  }, /*#__PURE__*/React__default["default"].createElement(index$9["default"], {
    ref: footerRef,
    divider: true,
    above: !params.above700 && getPreviewItemCard(true),
    buttons: footerButtons,
    onEvent: handleFooterEvent
  })), layout === 'footerAbsolute' && /*#__PURE__*/React__default["default"].createElement(index$8["default"], {
    absolute: true,
    removePadding: "inline"
  }, /*#__PURE__*/React__default["default"].createElement(index$9["default"], {
    ref: footerRef,
    divider: true,
    above: !params.above700 && getPreviewItemCard(true),
    buttons: footerButtons,
    onEvent: handleFooterEvent
  })))), (layout === 'default' || !layout) && /*#__PURE__*/React__default["default"].createElement(styles.BackButtonWrapper, null, /*#__PURE__*/React__default["default"].createElement(index$a.BackButton, {
    onBack: handleBack
  })));
};
const ReturnReasonsRawWrapped = props => {
  const {
    panelcontainerNoneNone,
    selecteditemNoneNone,
    buttonsPrimaryDefault,
    buttonsSecondaryDefault,
    bodytextDefaultNone,
    documentbodyNoneNone
  } = nthHookTheme.useTheme();
  return /*#__PURE__*/React__default["default"].createElement(styled.ThemeProvider, {
    theme: {
      panelcontainerNoneNone,
      selecteditemNoneNone,
      buttonsPrimaryDefault,
      buttonsSecondaryDefault,
      bodytextDefaultNone,
      documentbodyNoneNone
    }
  }, /*#__PURE__*/React__default["default"].createElement(ReturnReasonsRawComponent, props));
};
const ReturnReasonsRaw = nthHookSettings.withSettingsProvider(nthHookTranslations.withTranslationsProvider(nthHookTheme.withThemeProvider(ReturnReasonsRawWrapped, {
  themeTokens: tokens.themeTokens
}), {
  translationKeys: tokens.translationKeys
}), {
  settingsRequested: `
      returnReasons {
        returnQuantityMustBeAll
      }
      itemDisplay {
        additionalItemAttributeConfig {
          attribute
          value {
            concatKey
            concatPosition
            label
            transform
          }
        }
        itemAttributeConfig
      }
    `
});

exports.ReturnReasonsRaw = ReturnReasonsRaw;
